import * as React from 'react';
import { useRecoilValue } from 'recoil';
import { useIntl } from 'react-intl';
import DistanceWidget from './widgets/DistanceWidget';
import SpeedWidget from './widgets/SpeedWidget';
import EventsWidget from './widgets/EventsWidget';
import EcoScoreWidget from './widgets/EcoScoreWidget';
import DatePlaceWidget from './widgets/DatePlaceWidget';
import SelectRidesWidget from './widgets/SelectRidesWidget';
import { IRide } from './types';
import { localForageStore } from '../../store/localForageStore';
import { activeRideNumberAtom } from './RidePlayerState';

interface MultiRidePanelProps {
  rides: IRide[];
}

function MultiRidePanel(props: MultiRidePanelProps): JSX.Element {
  const { formatMessage: f } = useIntl();
  const activeRideNumber = useRecoilValue<number>(activeRideNumberAtom);

  const handleClose = () => {
    // window.close() doesn't work, if new window has not been opened by current browser
    localForageStore.removeItem('rides');
    window.close();
  };

  return (
    <div className="w-map w-map--wrapper" style={{ position: 'absolute', top: 0, left: '50%' }}>
      <div className="w-map">
        <div className="b-widgets-info" style={{ position: 'inherit', overflow: 'inherit' }}>
          <div className="b-tabs-toggler">
            <ul>
              <li className="active">
                <a href="#" style={{ width: 'auto', overflow: 'hidden' }}>
                  {`${
                    props.rides[activeRideNumber - 1]
                      ? `${
                          props.rides[activeRideNumber - 1].rideData.licenceNumber
                            ? `${props.rides[activeRideNumber - 1].rideData.licenceNumber} `
                            : ''
                        } ${
                          props.rides[activeRideNumber - 1].rideData.driverName
                            ? `${props.rides[activeRideNumber - 1].rideData.driverName}`
                            : ''
                        }`
                      : ''
                  }`}
                </a>
              </li>
              <li className="tab-actions" />
              <li className="tab-actions">
                <a
                  title={f({ id: 'ridePlayer.button.close.tooltip' })}
                  href="#"
                  className="cmd-icon cmd-icon-remove-sm"
                  onClick={handleClose}
                >
                  {/* &nbsp; */}
                </a>
              </li>
            </ul>
          </div>
          <div className="b-widgets-info-tab-content">
            <div
              className="b-widget-grid  b-widget-grid--rounded b-widget-grid--static"
              style={{ gridTemplateColumns: 'repeat(6, 1fr)' }}
            >
              <DatePlaceWidget size={4} rides={props.rides} />
              <div className="item" />
              <div className="item" />
              <div className="item" />
              <SpeedWidget rides={props.rides} />
              <EcoScoreWidget rides={props.rides} />
              <SelectRidesWidget rides={props.rides} />
              <DistanceWidget rides={props.rides} />
              <EventsWidget rides={props.rides} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MultiRidePanel;
